// extracted by mini-css-extract-plugin
var _1 = "zoom__icon__pduT3";
var _2 = "zoom__input__OmmCn";
export { _1 as "zoomIcon", _2 as "zoomInput" }
